import { render, staticRenderFns } from "./MarketApproveAppeal.vue?vue&type=template&id=27144cc7"
import script from "./MarketApproveAppeal.vue?vue&type=script&lang=js"
export * from "./MarketApproveAppeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports